import { render } from "./DashboardConfigurationCard.vue?vue&type=template&id=bc5cbf1a"
import script from "./DashboardConfigurationCard.vue?vue&type=script&lang=js"
export * from "./DashboardConfigurationCard.vue?vue&type=script&lang=js"

import "./DashboardConfigurationCard.vue?vue&type=style&index=0&id=bc5cbf1a&lang=css"
script.render = render

export default script